export const constants = {
	title: 'Join our Beta ',
	descr: `Start developing in the cloud today.`,
}
